var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.69,
    height: 23.15,
    viewBox: "0 0 24.69 23.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mbri-logout",
    d: "M3.328,7.911.224,11a.807.807,0,0,0,0,1.114l3.1,3.094c.7.694,1.781-.417,1.068-1.111L1.821,11.584,4.393,9.022c.73-.73-.444-1.735-1.069-1.111ZM5.4,10.8h7.716a.772.772,0,1,1,0,1.543H5.4A.772.772,0,0,1,5.4,10.8ZM9.259,0A3.1,3.1,0,0,0,6.172,3.087V6.945a.772.772,0,0,0,1.543,0V3.087A1.523,1.523,0,0,1,9.259,1.543H21.6a1.523,1.523,0,0,1,1.543,1.543V20.063A1.523,1.523,0,0,1,21.6,21.607H9.259a1.523,1.523,0,0,1-1.543-1.543V16.2a.772.772,0,0,0-1.543,0v3.858A3.1,3.1,0,0,0,9.259,23.15H21.6a3.1,3.1,0,0,0,3.086-3.087V3.087A3.1,3.1,0,0,0,21.6,0Z",
    transform: "translate(0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLogout);
export default __webpack_public_path__ + "static/media/black_logout.a4aebd021c84c9df8972a61250c5b819.svg";
export { ForwardRef as ReactComponent };